import * as React from 'react';
import { styled } from '@mui/material';
import Column from 'src/frontend-common/components/Column';
import SecurityTab from './Security';
import { useGetCurrentUserQuery } from 'src/redux/services/users';
import { PartialUser } from 'src/dto/User';

const BodyContainer = styled(Column)(({ theme }) => ({
  marginTop: theme.spacing(0),
}));

const Security: React.FC = () => {
  const { data: userData } = useGetCurrentUserQuery();

  let user: PartialUser | null = null;
  if (userData) {
    user = userData.item;
  }
  return (
    <BodyContainer data-cy="settings-my-profile-tab">
      <SecurityTab user={user} />
    </BodyContainer>
  );
};

export default Security;
